// Constants for Ditan Attorney Compliance Portal

import type { AppRole } from '@/types/auth';

// Roles
export const ROLES: AppRole[] = ['super_admin', 'lesson_admin', 'client_admin', 'employee'];

export const ROLE_LABELS: Record<AppRole, string> = {
  super_admin: 'Super Admin',
  lesson_admin: 'Lesson Admin',
  client_admin: 'Client Admin',
  employee: 'Employee',
};

// Password validation rules
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,}$/;
export const PASSWORD_REQUIREMENTS = 'Password must be at least 8 characters with at least 1 number';

// Form field limits
export const FULL_NAME_MAX_LENGTH = 100;
export const EMAIL_MAX_LENGTH = 255;
export const EMPLOYEE_ID_MAX_LENGTH = 50;

// App info
export const APP_NAME = 'Ditan Compliance';
export const APP_DESCRIPTION = 'Attorney Compliance Training Portal';

// Routes
export const ROUTES = {
  HOME: '/',
  WELCOME: '/welcome',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  PENDING: '/pending',
  DASHBOARD: '/dashboard',
  MY_RECORDS: '/my-records',
  PROFILE: '/profile',
  POLICIES: '/policies',
  CERTIFICATE_VERIFY: '/verify/:certificateId',
  // Admin routes
  ADMIN: '/admin',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_USERS: '/admin/users',
  ADMIN_DEPARTMENTS: '/admin/departments',
  ADMIN_MODULES: '/admin/modules',
  ADMIN_POLICIES: '/admin/policies',
  ADMIN_RECORDS: '/admin/records',
  ADMIN_COMPLIANCE: '/admin/compliance',
  ADMIN_COMPLIANCE_SETTINGS: '/admin/settings/compliance',
} as const;

// Public routes (no auth required)
export const PUBLIC_ROUTES = [
  ROUTES.HOME,
  ROUTES.WELCOME,
  ROUTES.LOGIN,
  ROUTES.REGISTER,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD,
  '/verify', // Certificate verification (prefix match)
];

// Digital Acceptance Legal Text
export const ACCEPTANCE_TEXT = `I confirm that:
• I have completed this training and achieved a score of 100% on the self-assessment
• I have read and understood the company policies listed above
• I agree to comply with these policies in my employment
• I understand this acceptance is being recorded with my ID, photo, timestamp, and IP address for audit purposes`;
